module.exports = __webpack_public_path__ + "img/austria-cardiovascular-diseases-female.499e4788.png";